/* Mobile menu drawer → browser TOP LAYER.

   The category/subcategory drawer is born inside `.header` (position:static +
   `contain: layout`) which lives at a LOW page-level stacking layer — below the
   bottom dock (search/cart/whatsapp z~9999), the buy pills, the product badges
   and the sort filter. Because z-index only ranks WITHIN a stacking context, no
   z-index on the drawer can ever climb out of that trap.

   The cart and the product quick-view overlay everything because they use the
   browser TOP LAYER (a <dialog>/popover renders above the whole page regardless
   of any ancestor's z-index). So we do the same: when the drawer opens we call
   showPopover() on the drawer + its dimming backdrop, promoting them to the top
   layer. No DOM is moved, so the theme's own open/close logic and animations
   keep working. Mobile only — desktop uses a dropdown, not this drawer. */
(function () {
  function init() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    if (typeof HTMLElement === 'undefined' || !HTMLElement.prototype.showPopover) return; // no Popover API → leave as-is

    var drawer = details.querySelector('.menu-drawer');
    var backdrop = details.querySelector('.menu-drawer__backdrop');
    if (!drawer) return;

    [drawer, backdrop].forEach(function (el) {
      if (el && !el.hasAttribute('popover')) el.setAttribute('popover', 'manual');
    });

    var closeTimer;
    function show(el) {
      if (!el) return;
      try { if (!el.matches(':popover-open')) el.showPopover(); } catch (e) {}
    }
    function hide(el) {
      if (!el) return;
      try { if (el.matches(':popover-open')) el.hidePopover(); } catch (e) {}
    }

    function sync() {
      var open = details.classList.contains('menu-open');
      if (open) {
        clearTimeout(closeTimer);
        show(backdrop);
        show(drawer);
      } else {
        // Keep it in the top layer through the slide-out animation, then drop.
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { hide(drawer); hide(backdrop); }, 360);
      }
    }

    new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['class'] });

    // Desktop safety net: on a wide screen the hamburger only appears when the top
    // nav overflows (data-menu-style='drawer'). If the user opens the drawer and
    // then widens the window, the header flips back to 'menu' but the <details>
    // can stay open — leaving the popover in the top layer and the dock/pills
    // hidden. Close the drawer whenever the header leaves 'drawer' mode.
    var headerComp = document.getElementById('header-component');
    if (headerComp) {
      new MutationObserver(function () {
        if (headerComp.getAttribute('data-menu-style') !== 'drawer' && details.classList.contains('menu-open')) {
          details.classList.remove('menu-open');
          details.removeAttribute('open');
          var s = details.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
          hide(drawer);
          hide(backdrop);
        }
      }).observe(headerComp, { attributes: true, attributeFilter: ['data-menu-style'] });
    }

    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
